import * as React from "react";
import * as Rest from "../../Generated/RestClient"
import { clientAppSettings } from "../../Models/ClientAppSettings";
import { BotImageControl } from "../../../../Intercom.ReactUI/Views/index";
import { BotUtilsV2 } from '../../Utils/BotUtils';
import { FlightUtils } from '../../Utils/FlightUtils';
import { Resources } from "../../Resources/Intercom.Resources.DevPortal";

export class BotsPageRowState {
    isAzureIbizaBot: boolean;
    isMigratedBot: boolean;
    isMigrationOptional: boolean;
}

export class BotsPageRowProps {
    bot: Rest.BotDocument;
    onClickBotName: (bot: Rest.BotDocument) => void;
    onClickMigrate: (botId: string) => void;
    onClickRollback: (botId: string) => void;
    onClickDelete: (botId: string) => void;
}

export class BotsPageRow extends React.Component<BotsPageRowProps, BotsPageRowState> {
    constructor(props) {
        super(props);

        const isAzureIbizaBot = BotUtilsV2.isAzureIbizaBot(this.props.bot);
        const isMigratedBot = BotUtilsV2.isMigratedBotDocument(this.props.bot);
        const isMigrationOptional = BotUtilsV2.isMigrationOptional(this.props.bot);

        this.state = {
            isAzureIbizaBot: isAzureIbizaBot,
            isMigratedBot: isMigratedBot,
            isMigrationOptional: isMigrationOptional
        };
    }

    /** Renders a migrate or rollback button */
    private getMigrationAction(): JSX.Element {
        if (this.state.isAzureIbizaBot) {
            if (this.state.isMigratedBot) {
                let oneWeekAgo = new Date();
                oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
                const md = new Date(String(this.props.bot.MigratedDate));
                const rollbackBtn = this.props.bot.MigratedDate && md >= oneWeekAgo
                    ? <button className={"m-button-primary-md bots-page-migration-button"} onClick={() => this.props.onClickRollback(this.props.bot.Id)}>{ Resources.myBotsMigrationButtonRollback }</button>
                    : null;
                    
                return (
                    <div>
                        <span className="m-icon-Info migration-icon"></span>{' '}
                        <span className={"bots-page-row-status-text"}>{Resources.myBotsMigrationStatusMigrated}</span>
                        { rollbackBtn }
                    </div>
                );
            }
            return (<div></div>);
        } else {
            if (this.state.isMigrationOptional) {
                return (
                    <div>
                        <a href="https://docs.microsoft.com/en-us/azure/bot-service/bot-service-migrate-bot" target="_blank">
                            <span className="m-icon-Info migration-icon"></span>
                        </a>{' '}
                        <span className={"bots-page-row-status-text"}>{Resources.myBotsMigrationStatusOptionalMigration}</span>
                        <button className={"m-button-primary-md bots-page-migration-button"} onClick={() => this.props.onClickMigrate(this.props.bot.Id)}>{ Resources.myBotsMigrationButtonMigrate }</button>
                    </div>
                );
            }
            const disabledUntilMigrated = !this.state.isMigratedBot && FlightUtils.areMigrationRequiredBotsDisabled;
            const disabledIcon = disabledUntilMigrated ? <span className="m-icon-AlertTriangle migration-icon"></span> : null;
            return (
                <div>
                    { disabledIcon }{' '}
                    <span className={"bots-page-row-status-text"}>{Resources.myBotsMigrationStatusNotMigrated}</span>
                    <button className={"m-button-primary-md bots-page-migration-button"} onClick={() => this.props.onClickMigrate(this.props.bot.Id)}>{ Resources.myBotsMigrationButtonMigrate }</button>
                </div>
            );
        }
    }

    private getContextAction(): JSX.Element {
        if (this.state.isAzureIbizaBot || this.state.isMigratedBot) {
            return (
                <div className={"bots-page-row-delete"}></div>
            );
        }
        return (
            <div className={"bots-page-row-delete"}>
                <button className={"bots-page-row-delete-button"} onClick={() => this.props.onClickDelete(this.props.bot.Id)}>
                    <span className={"m-icon-delete"}></span>
                </button>
            </div>
        );
    }

    /** Renders the component */
    public render(): JSX.Element {

        return (
            <div className={"bots-page-row"}>
                <div className={"bots-page-row-name"}>
                    <BotImageControl bot={this.props.bot} className="bots-page-icon"
                        transparentBackground={false}
                        defaultIconUrl={clientAppSettings.defaultIconUrl}/>
                    <button className={"bots-page-row-name-button"} onClick={() => this.props.onClickBotName(this.props.bot)}>
                        <span className={"bots-page-row-botname"}>{ this.props.bot.Name || '(unnamed)' }</span>
                    </button>
                </div>
                <div className={"bots-page-row-status"}>
                    {this.getMigrationAction()}
                    {this.getContextAction()}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./Client/v4/Views/BotsPageRow.tsx